import styled from 'styled-components';
import { motion } from 'framer-motion';
import { white, primary } from 'constants/color';

export const ActionButton = styled(motion.button)`
  height: 25px;
  border: none;
  cursor: pointer;
  box-shadow: none;
  background: none;
  svg {
    width: 25px;
    height: 25px;
    fill: ${primary};
  }
`;

export const StyledTableWrapper = styled.div`
  overflow: auto;
  padding: 10px 20px 0 10px;
  background-color: ${white};
  ${({ theme }) => theme.scrollbar};
  border-radius: ${({ theme }) => theme.borderRadius};

  /* Mobile Devices */
  @media (max-width: 480px) {
    margin-left: 5px;
    margin-right: 5px;
    margin-bottom: 20px;
  }
`;

export const StyledItemTag = styled.span`
  height: 22px;
  font-size: 12px;
  color: ${white};
  padding: 2px 5px;
  line-height: 18px;
  font-style: normal;
  font-weight: normal;
  background-color: ${({ backColor }) => backColor};
  border-radius: ${({ theme }) => theme.borderRadius};
`;

export const StyledListWrapper = styled.div`
  margin-right: 15px;

  /* Mobile Devices */
  @media (max-width: 480px) {
    margin-right: 5px;
  }

  /* Portrait Tablets and Ipads */
  @media (min-width: 768px) and (max-width: 1024px) {
    margin-right: 0px;
  }
`;

export const StyledName = styled.span`
  height: 80px;
  font-size: 12px;
  line-height: 18px;
  font-style: normal;
  font-weight: normal;
`;
